import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function StaffListMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.systemSetting.employee.list("staff"));
  };

  return (
    <MainMenuItem
      itemTitleString="スタッフ情報を見る"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default StaffListMenuItem;
